export default __webpack_public_path__ + "static/tires-four-166d67714896095fdb63748ad69a5475.svg";